class HoverPopover extends HTMLElement {
  static MARGIN = 10;
  #id;

  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
    this.#id = crypto.randomUUID();

    this.shadowRoot.innerHTML = `
      <style>
        :host {
          display: inline-block;
          position: relative;
          font-family: inherit;
        }

        .trigger {
          border: none;
          cursor: pointer;
          text-decoration: var(--popover-trigger-decoration, underline);
          font-size: var(--popover-trigger-size, inherit);
          display: inline-block;
          anchor-name: --trigger;
          position: relative;
          background: 0;
          padding: 0;
          margin: 0;
          color: inherit;
          font-family: inherit;
        }

        :host > [popover] {
          pointer-events: none;
          border-radius: 8px;
          padding: 10px 12px;
          position-anchor: --trigger;
          position: fixed;
          inset: unset;
          border: 1px solid var(--COLOR-BORDER, rgba(0,0,0,0.12));
          background: var(--COLOR-BG, #fff);
          color: var(--COLOR-TEXT, #282c2e);
          font-size: 0.8rem;
          font-family: var(--FONT-STACK-BODY, sans-serif);
          line-height: 1.5;
          box-shadow: 0 4px 16px rgba(0,0,0,0.10);
          margin: ${HoverPopover.MARGIN}px;
          width: max-content;
          max-width: min(calc(100vw - ${HoverPopover.MARGIN * 4}px), 240px);
          left: clamp(
            0px,
            calc(anchor(50%) - var(--popover-width) / 2),
            calc(100vw - var(--popover-width))
          );
          top: clamp(
            0px,
            calc(anchor(top) - var(--popover-height)),
            calc(100vh - var(--popover-height))
          );
        }
      </style>
      <button class="trigger" role="button" popovertarget="${this.#id}"><slot></slot></button>
      <div popover="hint" id="${this.#id}"><slot name="popover"></slot></div>
    `;

    this.triggerElement = this.shadowRoot.querySelector('.trigger');
    this.popoverElement = this.shadowRoot.querySelector(':host > [popover]');
  }

  connectedCallback() {
    // Hover
    this.triggerElement.addEventListener('mouseenter', this.show);
    this.triggerElement.addEventListener('mouseleave', this.hide);

    // Focus (keyboard accessibility)
    this.triggerElement.addEventListener('focus', this.show);
    this.triggerElement.addEventListener('blur', this.hide);

    this.popoverElement.addEventListener('toggle', (e) => {
      if (e.newState !== 'open') return;

      this.style.setProperty(
        '--popover-width',
        `${this.popoverElement.offsetWidth + HoverPopover.MARGIN * 2}px`
      );
      this.style.setProperty(
        '--popover-height',
        `${this.popoverElement.offsetHeight + HoverPopover.MARGIN * 2}px`
      );
    });
  }

  show = () => {
    this.popoverElement.showPopover();
  };

  hide = () => {
    this.popoverElement.hidePopover();
  };

  toggle = () => {
    this.popoverElement.togglePopover();
  };
}

customElements.define('hover-popover', HoverPopover);
